var _path, _path2, _path3, _path4, _g, _g2, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path6, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1097.1,
    height: 807.9,
    viewBox: "0 0 1097.1 807.9",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3,476c17.36,74.2,54.11,138.34,112.19,169.43,120.7,64.61,392.91,31.29,596.07-7a465.21,465.21,0,0,0,264.54-151.23Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.65,126.76H1017.18a9.63,9.63,0,1,1,0-19.27h19.27a9.63,9.63,0,0,1,0-19.27h-13.76a9.63,9.63,0,0,1,0-19.27h58.18c-12.91-6-28-10.27-45.38-12.51-158.64-20.38-215.28-6.9-235.26,7-24.65,17.1-52.15,29.68-81.54,35.74-97.88,20.19-280.93,44.49-446.84-7.78-82.46-26-143.75,17.92-180.48,91.28H1148c-1.38-21.32-5.51-41-13.09-58.24A9.58,9.58,0,0,1,1128.65,126.76Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.84,321.15A491.06,491.06,0,0,0,58.16,450.6l978.68,35.79a460,460,0,0,0,68-103.7ZM440.92,413.5H421.65a9.63,9.63,0,1,1,0,19.27H310.18a9.63,9.63,0,1,1,0-19.27h19.27a9.63,9.63,0,0,1,0-19.27H315.69a9.63,9.63,0,0,1,0-19.27H427.16a9.63,9.63,0,1,1,0,19.27h13.76a9.63,9.63,0,0,1,0,19.27Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.05,183.34l-1068.49,26C66.57,242.74,58,280.51,54,319.67H1129.33a456.46,456.46,0,0,0,15.53-70.33C1148.06,226.32,1149.34,204.07,1148.05,183.34ZM270.92,268.5H251.65a9.63,9.63,0,1,1,0,19.27H140.18a9.63,9.63,0,1,1,0-19.27h19.27a9.63,9.63,0,0,1,0-19.27H145.69a9.63,9.63,0,0,1,0-19.27H257.16a9.63,9.63,0,1,1,0,19.27h13.76a9.63,9.63,0,0,1,0,19.27Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729,669.33s28.2-69.5,80.86-95.28A113.65,113.65,0,0,0,861.47,524,191.13,191.13,0,0,0,874.4,491.5",
    transform: "translate(-51.45 -46.05)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.49,475.05c-5.49,6.9-33.9,17-33.9,17s3.42-30,8.91-36.85a16,16,0,0,1,25,19.88Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.74,529.71c-8.36,2.81-37.68-4.18-37.68-4.18s19.15-23.28,27.51-26.09a16,16,0,0,1,10.17,30.27Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.88,594.31c-8.63-1.79-30.42-22.63-30.42-22.63s28.28-10.43,36.92-8.64a16,16,0,0,1-6.5,31.26Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.88,634.19c-8.81-.31-33.81-17.16-33.81-17.16S786.19,602,795,602.28a16,16,0,1,1-1.12,31.91Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.76,506c1.13,8.75,20.22,32.07,20.22,32.07s12.57-27.4,11.45-36.15A16,16,0,0,0,832.76,506Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.7,553.39c3.69,8,28.89,24.55,28.89,24.55s3.8-29.91.11-37.91a16,16,0,1,0-29,13.37Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.62,607.33c2.28,8.52,24.33,29.08,24.33,29.08s8.8-28.83,6.51-37.35a16,16,0,0,0-30.84,8.27Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.49,475.05c-5.49,6.9-33.9,17-33.9,17s3.42-30,8.91-36.85a16,16,0,0,1,25,19.88Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.74,529.71c-8.36,2.81-37.68-4.18-37.68-4.18s19.15-23.28,27.51-26.09a16,16,0,0,1,10.17,30.27Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.88,594.31c-8.63-1.79-30.42-22.63-30.42-22.63s28.28-10.43,36.92-8.64a16,16,0,0,1-6.5,31.26Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.88,634.19c-8.81-.31-33.81-17.16-33.81-17.16S786.19,602,795,602.28a16,16,0,1,1-1.12,31.91Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.76,506c1.13,8.75,20.22,32.07,20.22,32.07s12.57-27.4,11.45-36.15A16,16,0,0,0,832.76,506Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.7,553.39c3.69,8,28.89,24.55,28.89,24.55s3.8-29.91.11-37.91a16,16,0,1,0-29,13.37Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.62,607.33c2.28,8.52,24.33,29.08,24.33,29.08s8.8-28.83,6.51-37.35a16,16,0,0,0-30.84,8.27Z",
    transform: "translate(-51.45 -46.05)",
    opacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709,567.71s3.56-74.92,44.69-116.71a113.65,113.65,0,0,0,32-64.35,191.13,191.13,0,0,0,1.43-34.92",
    transform: "translate(-51.45 -46.05)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813,325.24c-2.89,8.33-26.35,27.26-26.35,27.26s-6.7-29.39-3.81-37.72A16,16,0,1,1,813,325.24Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.88,380c-7,5.42-36.94,8.56-36.94,8.56s10.35-28.32,17.3-33.74A16,16,0,1,1,821.88,380Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.43,458.52c-8.74,1.17-36.2-11.26-36.2-11.26s23.23-19.22,32-20.39a16,16,0,1,1,4.24,31.65Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.54,513.05c-8.42,2.63-37.59-5-37.59-5s19.64-22.87,28.06-25.5a16,16,0,0,1,9.53,30.48Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.71,379.22c4,7.88,29.72,23.55,29.72,23.55s2.77-30-1.19-37.9a16,16,0,0,0-28.53,14.35Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.71,443.52c6.14,6.33,35.4,13.58,35.4,13.58s-6.33-29.47-12.47-35.8a16,16,0,0,0-22.93,22.23Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.41,511.34c5,7.28,32.6,19.37,32.6,19.37s-1.26-30.12-6.24-37.4a16,16,0,0,0-26.35,18Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.19,821.81c39.32,13.22,87.29,5.18,131.9,6.11,6.11.13,12.57.51,17.47,2.79s7.31,6,10.67,9.15c12.5,11.79,38.11,15.58,60.5,13.58s42.92-8.62,64-13.66c36.52-8.72,78.27-12.68,114.29-3.18,3.31.87,6.79,1.87,10.33,1.53,7.9-.78,10.25-7.1,15.77-10.71,10-6.52,31.63-4.75,36-13.34,2.57-5-3.34-10.2-9.77-13.64-24.62-13.16-59.84-15.33-92.06-13.3s-63.9,7.63-96.29,7.65c-40.35,0-79.34-8.59-119.3-12.11-27.68-2.44-57.89-2.14-83.84,5C382.81,795.5,376.61,812.94,351.19,821.81Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#eeb808",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 365.51,
    y: 184.9,
    width: 7,
    height: 99,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 365.51,
    y: 317.9,
    width: 7,
    height: 56,
    fill: "#535461"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 370.51,
    y: 87.9,
    width: 315,
    height: 684,
    rx: 47.1,
    ry: 47.1,
    fill: "#535461"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 370.51,
    y: 119.9,
    width: 315,
    height: 623,
    rx: 47.1,
    ry: 47.1,
    fill: "#eeb808"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 502.51,
    y: 102.9,
    width: 52,
    height: 7,
    rx: 3.5,
    ry: 3.5,
    fill: "#eaeaf3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 572.51,
    cy: 106.9,
    r: 5,
    fill: "#eaeaf3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M497.76,442.15v73a17.27,17.27,0,0,1-17.33,17.46c-9.64,0-19-7.81-19-17.46v-73c0-9.52,9.33-17.33,19-17.33A17.4,17.4,0,0,1,497.76,442.15Zm6.81,98.94a18.61,18.61,0,0,0,18.65,18.65h12.54l.19,38.51c0,23.25,34.79,23.07,34.79,0V559.75h23.44v38.51c0,23.13,35,23.19,35,0V559.75h12.73a18.59,18.59,0,0,0,18.53-18.65V428H504.57ZM660.86,421.92h-157c0-27,16.13-50.42,40.08-62.64l-12-22.25c-1.76-3.09,2.71-5,4.22-2.39l12.23,22.44a85.14,85.14,0,0,1,68.25,0l12.16-22.37c1.58-2.71,6-.69,4.22,2.39l-12,22.18C644.73,371.5,660.86,394.95,660.86,421.92Zm-107.58-35a6.62,6.62,0,0,0-6.62-6.62,6.62,6.62,0,0,0,0,13.23A6.62,6.62,0,0,0,553.28,386.94Zm71.47,0a6.52,6.52,0,1,0-6.43,6.62A6.58,6.58,0,0,0,624.75,386.94Zm59.74,37.88a17.28,17.28,0,0,0-17.33,17.33v73a17.39,17.39,0,0,0,17.33,17.46c9.71,0,19-7.81,19-17.46v-73C703.46,432.45,694.13,424.82,684.49,424.82Z",
    transform: "translate(-51.45 -46.05)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 454.01,
    y: 569.46,
    width: 65,
    height: 3,
    fill: "#535461"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 543.01,
    y: 569.46,
    width: 43,
    height: 3,
    fill: "#535461"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 397.01,
    y: 569.46,
    width: 43,
    height: 3,
    fill: "#535461"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 611.01,
    y: 569.46,
    width: 43,
    height: 3,
    fill: "#535461"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.b635b8f3a317ed7a643ba5e334801a92.svg";
export { ForwardRef as ReactComponent };